import * as Types from '../constants/Types';

export const dataOrderAction = (filters) => ({ type: Types.ORDER_LIST_ACTION, filters });
export const dataOrderSuccess = (orders, filters) => ({ type: Types.ORDER_LIST_SUCCESS, orders, filters });

export const getOrderDetail = (id) => ({ type: Types.ORDER_DETAIL_ACTION, id });
export const setOrderDetail = (order) => ({ type: Types.ORDER_DETAIL_SUCCESS, order });

export const getOrderDetailGolf = (vptOrderId) => ({ type: Types.ORDER_DETAIL_GOLF_ACTION, vptOrderId });
export const setOrderDetailGolf = (orderGolf) => ({ type: Types.ORDER_DETAIL_GOLF_SUCCESS, orderGolf });

export const getOrderItemAction = (id) => ({ type: Types.ORDER_ITEM_GET_ACTION, id });
export const getOrderItemSuccess = (orderItem) => ({ type: Types.ORDER_ITEM_GET_SUCCESS, orderItem });

export const getItemVoucherOrderAction = (params) => ({ type: Types.ORDER_VOUCHER_GET_ITEM_ACTION, params });
export const getItemVoucherOrderSuccess = (itemBooking) => ({ type: Types.ORDER_VOUCHER_GET_ITEM_SUCCESS, itemBooking });

export const getDetailVoucherOrderAction = (params) => ({ type: Types.ORDER_VOUCHER_GET_DETAIL_VOUCHER_ACTION, params });
export const getDetailVoucherOrderSuccess = (data) => ({ type: Types.ORDER_VOUCHER_GET_DETAIL_VOUCHER_SUCCESS, ...(data || {}) });

export const getInfoVoucherDetailGroupAction = (params) => ({ type: Types.ORDER_GET_INFO_DETAIL_GROUP_ACTION, params });
export const getInfoVoucherDetailGroupSuccess = (data) => ({ type: Types.ORDER_GET_INFO_DETAIL_GROUP_SUCCESS, ...(data || {}) });

export const reSendEmailOrderAction = (params) => ({ type: Types.ORDER_RESEND_EMAIL_ACTION, params });
export const reSendEmailOrderSuccess = (idReSendEmail) => ({ type: Types.ORDER_RESEND_EMAIL_SUCCESS, idReSendEmail });

export const getOrderFlightItem = (productVariantId) => ({ type: Types.ORDER_FLIGHT_GET_ITEM_ACTION, productVariantId });
export const setOrderFlightItem = (flight) => ({ type: Types.ORDER_FLIGHT_GET_ITEM_SUCCESS, flight });

export const getOrderHotelBooking = (productVariantIds) => ({ type: Types.ORDER_HOTEL_GET_BOOKING_ACTION, productVariantIds });
export const setOrderHotelBooking = (reservations) => ({ type: Types.ORDER_HOTEL_GET_BOOKING_SUCCESS, reservations });

export const getOrderHomestayBooking = (productVariantIds) => ({ type: Types.ORDER_HOMESTAY_GET_BOOKING_ACTION, productVariantIds });
export const setOrderHomestayBooking = (reservations) => ({ type: Types.ORDER_HOMESTAY_GET_BOOKING_SUCCESS, reservations });

export const getOrderCrossSellBooking = (productVariantIds) => ({ type: Types.ORDER_CROSSSELL_GET_BOOKING_ACTION, productVariantIds });
export const setOrderCrossSellBooking = (reservations) => ({ type: Types.ORDER_CROSSSELL_GET_BOOKING_SUCCESS, reservations });

export const exportExcel = (params) => ({ type: Types.ORDER_EXPORT_EXCEL_ACTION, params });
export const exportSkuExcel = (params) => ({ type: Types.ORDER_EXPORT_SKU_EXCEL_ACTION, params });
export const exportSkuSaleDetailExcel = (params) => ({ type: Types.ORDER_EXPORT_SKU_SALE_DETAIL_EXCEL_ACTION, params });
export const exportHotelSaleDetailExcel = (params) => ({ type: Types.ORDER_EXPORT_HOTEL_SALE_DETAIL_EXCEL_ACTION, params });

export const exportAccessTrade = (params) => ({ type: Types.ORDER_EXPORT_ACCESS_TRADE_ACTION, params });

export const sendEmailTemplate = (order, emailTemplate) => ({ type: Types.ORDER_SEND_EMAIL_TEMPLATE_ACTION, order, emailTemplate });

export const exportSaleOrder = (saleOrder, refreshParams) => ({ type: Types.ORDER_EXPORT_SALE_ORDER_ACTION, saleOrder, refreshParams });
export const exportTourSaleOrder = (tourSaleOrder, refreshParams) => ({ type: Types.ORDER_EXPORT_TOUR_SALE_ORDER_ACTION, tourSaleOrder, refreshParams})

export const updateOrder = (order) => ({ type: Types.ORDER_UPDATE_ACTION, order });
export const updateOrderAccountant = (order) => ({ type: Types.ORDER_UPDATE_ACCOUNTANT_ACTION, order });
export const updateFlight = (flight) => ({ type: Types.ORDER_FLIGHT_UPDATE_ACTION, flight })
export const updateOrderInvoice = (orderInvoice) => ({ type: Types.ORDER_UPDATE_INVOICE_ACTION, orderInvoice });

export const exportSaleOrderVoucherAction = (id) => ({ type: Types.ORDER_EXPORT_VOUCHER_ACTION, id });

export const recommitTourOrder = (id) => ({ type: Types.ORDER_TOUR_RECOMMIT_ACTION, id });
export const updateOrderStatus = (order) => ({ type: Types.ORDER_TOUR_UPDATE_STATUS_ACTION, order });

/* SURCHARGE ACTIONS */

export const openModalDetail = () => ({ type: Types.SURCHARGE_OPEN_MODAL });
export const closeModalDetail = () => ({ type: Types.SURCHARGE_CLOSE_MODAL });

export const getItemSurchargeOrder = (params, listType) => ({ type: Types.ORDER_SURCHARGE_GET_ITEM_ACTION, params, listType });
export const setItemSurchargeOrder = (surcharges) => ({ type: Types.ORDER_SURCHARGE_GET_ITEM_SUCCESS, surcharges });

export const getSurchargeDetail = (id) => ({ type: Types.SURCHARGE_ITEM_DETAIL_ACTION, id })
export const setSurchargeDetail = (surcharge) => ({ type: Types.SURCHARGE_ITEM_DETAIL_SUCCESS, surcharge });
export const setListSurcharges = (surcharges, params) => ({ type: Types.GET_ALL_SURCHARGE_SUCCESS, surcharges, params });

export const getBundleOrderSurcharge = (params) => ({ type: Types.GET_BUNDLE_ORDER_SURCHARGE_ACTION, params })
export const setBundleOrderSurcharge = (surcharges) => ({ type: Types.GET_BUNDLE_ORDER_SURCHARGE_SUCCESS, surcharges });
export const bundleOrderCreateSurchargeAction = (params) => ({ type: Types.BUNDLE_ORDER_CREATE_SURCHARGE_ACTION, params })
export const bundleOrderCancelSurchargeAction = (params) => ({ type: Types.BUNDLE_ORDER_CANCEL_SURCHARGE_ACTION, params });

export const updateSurchargeDetail = (surcharge) => ({ type: Types.SURCHARGE_ITEM_DETAIL_UPDATE_ACTION, surcharge });
export const createSurchargeDetail = (surcharge) => ({ type: Types.SURCHARGE_ITEM_DETAIL_CREATE_ACTION, surcharge });
export const deleteSurchargeDetail = (surcharge) => ({ type: Types.SURCHARGE_ITEM_DETAIL_DELETE_ACTION, surcharge });

export const updateOrderTourItem = (tourItem) => ({ type: Types.ORDER_UPDATE_TOUR_ITEM_ACTION, tourItem });

export const updateOrderItem = (item, callback) => ({ type: Types.ORDER_ITEM_UPDATE_STATUS_ACTION, item, callback });
export const lockOrderItem = (item) => ({ type: Types.ORDER_ITEM_LOCK_ACTION, item });

export const checkRedeemOrderItem = (data) => ({ type: Types.ORDER_ITEM_CHECK_REDEEM_ACTION, data });
export const setInfoRedeemItem = (redeemData) => ({ type: Types.ORDER_ITEM_CHECK_REDEEM_SUCCESS, redeemData });
export const redeemOrderItem = (item, index, callBack) => ({ type: Types.ORDER_ITEM_REDEEM_ACTION, item, index, callBack });



export const getAirline = () => ({ type: Types.GET_ALL_AIRLINE_ACTION });
export const setAirline = (alines) => ({ type: Types.GET_ALL_AIRLINE_SUCCESS, alines });

export const getAirport = () => ({ type: Types.GET_ALL_AIRPORT_ACTION });
export const setAirport = (airports) => ({ type: Types.GET_ALL_AIRPORT_SUCCESS, airports });

export const getRoutes = () => ({ type: Types.GET_ALL_ROUTES_ACTION });
export const setRoutes = (routes) => ({ type: Types.GET_ALL_ROUTES_SUCCESS, routes });

export const getVehicleTypes = () => ({ type: Types.GET_ALL_VEHICLE_TYPES_ACTION });
export const setVehicleTypes = (vehicleTypes) => ({ type: Types.GET_ALL_VEHICLE_TYPES_SUCCESS, vehicleTypes });

export const getVehicle = () => ({ type: Types.GET_ALL_VEHICLE_ACTION });
export const setVehicle = (vehicles) => ({ type: Types.GET_ALL_VEHICLE_SUCCESS, vehicles });

export const changeRateCode = (change) => ({ type: Types.CHANGE_RATE_CODE_ACTION, change });

export const recommitHotelBundle = (data) => ({ type: Types.ORDER_RECOMMIT_HOTEL_BUNDLE_ACTION, data });

export const pushFixCharge = (orderId) => ({ type: Types.ORDER_PUSH_FIXED_CHARGE_ACTION, orderId });
export const pushFixChargeSuccess = (order) => ({ type: Types.ORDER_PUSH_FIXED_CHARGE_SUCCESS, order });

export const getVinwonderCustomersAction = (id) => ({type: Types.VINWONDER_CUSTOMERS_GET_LIST_ACTION, id});
export const getVinwonderCustomersSuccess = (data) => ({ type: Types.VINWONDER_CUSTOMERS_GET_LIST_SUCCESS, data });

export const getSmsHistoriesAction = (id) => ({type: Types.SMS_HISTORIES_ACTION, id});
export const getSmsHistoriesSuccess = (data) => ({ type: Types.SMS_HISTORIES_SUCCESS, data });

export const resendSmsAction = (id, orderId) => ({type: Types.SMS_RESEND_ACTION, id, orderId});
export const resendSmsSuccess = (data) => ({ type: Types.SMS_RESEND_SUCCESS, data });

export const updateProfile = (profile,orderId) => ({type: Types.UPDATE_PROFILE_ACTION, profile, orderId});
export const updateProfileSuccess = (data) => ({type: Types.UPDATE_PROFILE_SUCCESS, data});

export const resendFixChargeAction = (id) => ({type: Types.FIXCHARGE_RESEND_ACTION, id});
export const resendFixChargeSuccess = (data) => ({type: Types.FIXCHARGE_RESEND_SUCCESS, data});

export const createFlightTracking = (data) => ({type:Types.CREATE_FLIGHT_TRACKING_ACTION, data});
export const createFlightTrackingSuccess = (result) => ({type: Types.CREATE_FLIGHT_TRACKING_SUCCESS, result});

export const updateFlightTracking = (data) => ({type: Types.UPDATE_FLIGHT_TRACKING_ACTION, data});
export const updateFlightTrackingSuccess = (result) => ({type: Types.UPDATE_FLIGHT_TRACKING_SUCCESS, result});

export const deleteFlightTracking = (data) => ({type: Types.DELETE_FLIGHT_TRACKING_ACTION, data});
export const deleteFlightTrackingSuccess = (result) => ({type: Types.DELETE_FLIGHT_TRACKING_SUCCESS, result});

export const getListFlightTrackingOrder = (orderId) => ({type: Types.GET_ALL_FLIGHT_TRACKING_ORDER_ACTION, orderId})
export const setListFlightTrackingOrder = (result) => ({type: Types.GET_ALL_FLIGHT_TRACKING_ORDER_SUCCESS, result})

export const repushAffiliateAction = (orderId, status) => ({ type: Types.AFFILIATE_REPUSH_ACTION, orderId, status });
export const repushAffiliateSuccess = (data) => ({ type: Types.AFFILIATE_REPUSH_SUCCESS, data });

export const getPointHistoriesAction = (id) => ({type: Types.POINT_HISTORIES_ACTION, id});
export const getPointHistoriesSuccess = (data) => ({ type: Types.POINT_HISTORIES_SUCCESS, data });

export const refundOrderPointAction = (id) => ({type: Types.REFUND_ORDER_POINT_ACTION, id});
export const refundOrderPointSuccess = (data) => ({ type: Types.REFUND_ORDER_POINT_SUCCESS, data});
export const refundOrderPointFail = (error) => ({ type: Types.REFUND_ORDER_POINT_FAIL, error: error });
